/**
 * @param {number} questionIndex - zero-based index
 * @returns {boolean}
 */
export function confirmDeleteTestQuestion(questionIndex) {
  const n = Number(questionIndex);
  const label = Number.isFinite(n) && n >= 0 ? `pregunta ${n + 1}` : "esta pregunta";
  return globalThis.confirm(
    `¿Eliminar ${label}? Esta acción no se puede deshacer hasta guardar el borrador de nuevo.`
  );
}
